import * as React from "react";
import "./ReportTypeLabel.scss";
import FlowType from "../commons/model/FlowType";

const ReportTypeLabel = ({ reportType }: { reportType: FlowType }) => {
  let className: string;
  let i18nKey: string;
  switch (reportType) {
    case FlowType.FULL_ASSESSMENT:
      className = "full-assessment-label";
      i18nKey = "Report.Type.FullAssessment";
      break;
    case FlowType.SMILE_ASSESSMENT:
      className = "smile-assessment-label";
      i18nKey = "Report.Type.SmileAssessment";
      break;
    case FlowType.SMILE_SIMULATION:
      className = "smile-simulation-label";
      i18nKey = "Report.Type.SmileSimulation";
      break;
  }
  return (
    <span className={className}>
      <span>{i18n[i18nKey]}</span>
    </span>
  );
};

export default ReportTypeLabel;
